import React, { useState,useEffect, useRef } from "react";
import DocumentCategory from "./DocumentCategory";
import Header from "../../components/header/component";
import Footer from "../../components/footer/component";
import ReactLoader from "../../components/resumebuild-loader/component";
import {
  userGuid,
  createUpdateDocumentUpload,
  checkDocumentUpload,
  jobCounter,
  getBlobUri,
  userGuidNormalizedForBlob,
  Dashboard_Upload_EventType,
  getTenantId,
  blobSignature,
} from "../../utils/general-config";
import { useTranslation } from "react-i18next";
import {
  changeToValidFileName,
  changeCommonlyUsedExt,
  checkValidExtensionForUploadFile,
  generateUinqueIDentifier,
  readCookie,
  getContentType,
  getCategoryName,
  replaceFileExtension,
  logout,
  successfullyResetToast,
  toLowercaseExtension,
  isPricingPageFlow,
  buildPricingPageUrl,
} from "../../utils/helpers";
import { postEventMethod, uploadDocs } from "./action";
import { generateSasUriToken } from "../../utils/generatesas";
import { BlobServiceClient } from "@azure/storage-blob";
import { endPoints, getDashboardOrchestrationServiceEndPoint } from "../../services/api-constants";
import { AuditData, AuditDataModel } from "../../services/event-service-api";
import { DashboardActionEnum, ImageType, JobStatusEnum, DocumentUpdateActionEnum } from "../../utils/enum-helper";
import { EMPTY_GUID } from "../../utils/constants";
import { useNavigate, useParams } from "react-router-dom";
import SuccessPopup from '../../components/secureSimpli-verification-popup/successPopup';
import PathHelper, { getLinkWithLocale, redirectToDashboardWithLocale } from "../../utils/path-helper";
import { getPdfSimpliBaseURL } from "../../services/api-constants";
import { ProcessSignInRequest } from "../../utils/document-helper";
import { getAllDocuments } from "./action";
import { LightBulbIcon } from "../../services/master-data"; 
import { permanentDeleteDocs } from "./action";

const documentCategories = [
    {
        id: "ids",
        title: "IDs and Personal Docs",
        description: "passport, license, SSN, birth/marriage cert",
        sensitive: true,
    },
    { id: "legal", title: "Legal Documents", description: "wills, trusts, contracts, deeds, custody", sensitive: true },
    { id: "financial", title: "Financial Records", description: "taxes, bank statements, loan docs", sensitive: true },
    {
        id: "receipts",
        title: "Receipts and Warranties",
        description: "insurance, bills, repairs, proof of purchase",
        sensitive: true,
    },
    {
        id: "digital",
        title: "Digital Memories and Files",
        description: "photos, videos, important computer backups",
        sensitive: true,
    },
    { id: "misc", title: "Miscellaneous", description: "medical records, pet info, travel docs", sensitive: true },
];
const SecureUpload = () => {
  // State to hold uploaded files, structure: { categoryId: [{id: '1', fileName: 'document-name.pdf', url: '...'}] }
   //const [uploadedFiles, setUploadedFiles] = useState(null);
    const [uploadedFiles, setUploadedFiles] = useState({
    ids: [],
    legal: [],
    financial: [],
    receipts: [],
    digital: [],
    misc: [],
  });

  const { t } = useTranslation();
  const fileInputRef = useRef(null);
  const activeCategoryId = useRef(null);

  const totalFiles = Object.values(uploadedFiles).flat().length;
  const [showLoader, setShowLoader] = useState("hidden");
  const [isProcessing, setIsProcessing] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [fileCount, setFileCount] = useState([]);
  const [fileAdded, setFileAdded] = useState([]);
  const [error, setError] = useState("");
  const [successPopUp, setSuccessPopUp] = useState(false);
  const queryParams = new URLSearchParams(window.location.search);
  const { locale } = useParams();
  let fileListPath = [];
  let updatedList = [];
  let validFileName = "";
  let folderPath = "";
  let isValidFile = false;
  let totalUploadCount = 0;
  let totalUploadedCount = 0;
  let unqnNameWithExtn = "";
  let uploadDocCount = 0;
  const sensitiveFilesUploaded = documentCategories
    .filter((cat) => cat.sensitive)
    .reduce((count, cat) => count + uploadedFiles[cat.id].length, 0);
  const userGUID = readCookie("userguid");

  // Triggers the hidden file input (the file selection popup)
  const handleAddFileClick = (category) => {
    const currentFiles = uploadedFiles[category.id].length;
    const categoryTitle = documentCategories.find((c) => c.id === category.id).title;

    if (currentFiles >= 3) {
      // Prevent opening the file dialog and show an alert
      alert(`You've reached the limit! You can only upload a maximum of 3 documents for ${categoryTitle}.`);
      return;
    }

    activeCategoryId.current = category.id;
    activeCategoryId.folderName = category.title;
    fileInputRef.current.click();
  };

  // Handles file selection, simulates API upload, and updates state
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    const categoryId = activeCategoryId.current
    const categoryFolderName = activeCategoryId.folderName;
    if (!file || !categoryId) {
      event.target.value = null;
      return;
    }

    // --- 3. Simulate API Upload ---
    console.log(`Simulating upload of file: ${file.name} to category: ${categoryId}`);

    // Clear the input value so the same file can be uploaded again if needed
    event.target.value = null;
    setShowLoader("block");
    await handleFileUpload(file, categoryId, categoryFolderName);
  };
  const checkFileUploadValidation = (file) => {
    validFileName = changeToValidFileName(file.name); // remove junk characters and validate file name
    var ext = validFileName.split(".").pop().toLowerCase();
    ext = changeCommonlyUsedExt(ext);
    let isValidExtension = checkValidExtensionForUploadFile(ext);
    isValidFile = isValidExtension == true ? true : setError(t("error_messages.wrong_format_msg"));

    return checkFileSize(file.size);
  };
  const checkFileSize = (fileSize) => {
    let isValidSize = "";
    if (fileSize / 1000 > 20000) {
      // $(".modal-footer #errorUploadLabel").text(ErrorMaximumSize);
      // $(".modal-footer").removeClass("hidden");
      setIsProcessing(false);
      setShowLoader("hidden");
      setError(t("error_messages.file_size_msg"));
      isValidSize = false;
    } else {
      isValidSize = true;
      setError("");
    }
    return isValidSize;
  };
  const checkFileUploadValidExtention = (fileList) => {
    // Assuming these variables and function exist in the surrounding scope
    // For this simplified function, we'll assume they are defined or passed in:
    // setError, t, setFileList, UniqueFolderPath

    setError("");
    let isValidExt = true;
    let fileSize = 0;

    // Regex for all allowed extensions (B2C/general)
    const generalRegex =
      /([a-zA-Z0-9 -_!@#$%^&*()|{}<>s_\\.-:])+(.pdf|.docx|.doc|.jpg|.jpeg|.png|.tiff|.tif|.ppt|.pptx|.xls|.xlsx|.odt)$/;

    // Regex for B2B/limited extensions
    const b2bRegex = /([a-zA-Z0-9 -_!@#$%^&*()|{}<>s_\\.-:])+(.pdf|.docx|.doc)$/;

    // 1. File Count Check
    if (fileList.length > 3) {
      // setError(t("conversion_tiles_modal.more_then_ten_files_error"));
      setError(t("conversion_tiles_modal.more_then_three_files_error"));
      return false;
    }
    
    // 2. File Extension and Size Check Loop
    for (const file of fileList) {
      fileSize += file.size; // Sum up file size

      // Check file extension based on orgId presence
      const currentRegex = generalRegex;

      if (!currentRegex.test(file.name.toLowerCase())) {
        setError(t("error_messages.wrong_format_msg"));
        setFileList([]); // Clear file list on error
        isValidExt = false;
        break; // Stop validation on first invalid file
      }
    }

    if (!isValidExt) {
      return false;
    }

    // 3. Total File Size Check (20MB limit)
    // fileSize is in bytes, (1000 * 1024) is 1MB, so we use 1000*20000 here to match the original logic (20MB)
    // Note: The original code uses `fileSize / 1000 > 20000`, which is 20,000,000 bytes or 20MB.
    if (fileSize / 1000 > 20000) {
      setError(t("error_messages.file_size_msg"));
      isValidExt = false;
      setIsProcessing(false);
      setShowLoader("hidden");
    }

    return isValidExt;
  };

   
  const handleFileUpload = async (file, categoryId, categoryFolderName) => {
    setIsProcessing(true);

    const newFileList = [...fileList, file];
    setFileList(newFileList);

    fileListPath = [];
    updatedList = [];

    // Validate file extensions
    if (!checkFileUploadValidExtention(newFileList)) {
      setIsProcessing(false);
      setShowLoader("hidden");
      setFileList([]);
      return false;
    } else {
      setError("");
      setFileList([]);
    }

    const ext = file.name.split(".").pop().toLowerCase();
    const contentType = getContentType(ext);
    const Filename = toLowercaseExtension(file.name);
    const fileSizeKB = parseInt(file.size / 1024);

    const auditData = AuditData(DashboardActionEnum.DASHBOARD_UPLOAD_MODAL, "", ext, fileSizeKB, Filename);
    const auditDataModel = AuditDataModel(
      "DOCUMENT",
      "DOCUMENT_UPLOADED",
      readCookie("visitorGuid"),
      readCookie("visitGuid"),
      userGUID,
      "",
      false,
      auditData
    );

    // Post event
    try {
      await postEventMethod(
        Dashboard_Upload_EventType,
        auditDataModel.SubCategory,
        userGUID,
        Dashboard_Upload_EventType,
        auditDataModel
      );
      console.log("Event posted successfully");
      setError(null);
    } catch (err) {
      console.error("Failed to post event", err);
    }

    // Image validation
    const imageArr = ["jpg", "png", "jpeg", "gif", "tiff"];
    if (imageArr.includes(ext)) {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);
      const imageValid = await new Promise((resolve) => {
        fileReader.onload = function () {
          const buf = new Uint8Array(fileReader.result);
          const key = (buf[1] << 8) + buf[0];
          if (!Object.values(ImageType).includes(key)) {
            setError("Please upload a valid image file");
            resolve(false);
          } else {
            resolve(true);
          }
        };
      });
      if (!imageValid) {
        setIsProcessing(false);
        setShowLoader("hidden");
        return;
      }
    } else if (!contentType) {
      setError(
        t("conversion_tiles_modal.invalid_file_format") +
          t("file_upload_popup.file_text") +
          t("conversion_tiles_modal.con_text")
      );
      setIsProcessing(false);
      setShowLoader("hidden");
      return;
    }

    // Check file upload limit
    if (!checkFileUploadValidation(file)) {
      setIsProcessing(false);
      setShowLoader("hidden");
      return;
    }

    totalUploadCount++;
    fileCount.push(totalUploadCount);
    setFileCount([...fileCount]);

    unqnNameWithExtn = generateUinqueIDentifier().toLowerCase();
    unqnNameWithExtn = unqnNameWithExtn.split("-").join("");
    unqnNameWithExtn = file.name.replace(/[^A-Za-z0-9._-]/gi, "").replace(".", "_" + unqnNameWithExtn + ".");
    unqnNameWithExtn = unqnNameWithExtn.substring(0, unqnNameWithExtn.lastIndexOf("."))?.replaceAll(/[.]/g, "");
    var updatedFileName = replaceFileExtension(unqnNameWithExtn, ext);
    unqnNameWithExtn = updatedFileName;

    let folderName = categoryFolderName;

    let blobUri = getBlobUri();
    let container = "pdfsimpliusers/";
    var userguid = userGuidNormalizedForBlob();
    let sasToken = await generateSasUriToken();

    if (fileCount.length > 10) {
      setError(t("conversion_tiles_modal.more_then_ten_files_error"));
      setFileList([]);
      setFileCount([]);
      setIsProcessing(false);
      setShowLoader("hidden");
      return false;
    }

    try {
      const blobServiceClient = new BlobServiceClient(blobUri + sasToken);
      const containerClient = blobServiceClient.getContainerClient(container + userguid);
      const blobClient = containerClient.getBlobClient(unqnNameWithExtn);
      const blockBlobClient = blobClient.getBlockBlobClient();

      await blockBlobClient.upload(file, file.size, {
        blockSize: 4 * 1024 * 1024,
        concurrency: 20,
        blobHTTPHeaders: { blobContentType: file.type },
      });

      file.blobUrl = decodeURIComponent(blockBlobClient.url.split("?")[0]);
      const data = {
        Filename: toLowercaseExtension(file.name),
         FolderName: folderName,
        //FolderName: "",
        UserId: userGUID,
        BlobUrl: file.blobUrl,
        DocumentProfile: {
          FolderPath: folderName,
          OriginalName: Filename,
          UniqueName: toLowercaseExtension(unqnNameWithExtn),
          SizeInKB: fileSizeKB,
          OriginalFileFormat: Filename.split(".").pop(),
          CategoryName: getCategoryName(ext),
          IsSharedInDrive: false,
          TenantId: getTenantId(),
          IsSecure: true,
        },
        ConversionAction: 1,
      };

      // Call uploadDocs directly (not Redux)
      const response = await uploadDocs(data);
      if (response && response?.status === 200 && response?.data?.documentProfile) {
        const unqn = generateUinqueIDentifier();

        const blobUrlLink = response?.data?.documentProfile?.originalFileUrl;
        const finalUrl = blobUrlLink
        const newFile = response?.data?.documentProfile;

        // Update state: Add the new file to the START of the array.
        setUploadedFiles((prev) => ({
          ...prev,
          [categoryId]: [newFile, ...prev[categoryId]],
        }));
        setIsProcessing(false);
        setFileCount([]);
        setShowLoader("hidden");
        setError(null);
        // uploadToastMessage();
      }
    } catch (error) {
      console.error("Upload failed", error);
      setIsProcessing(false);
      setShowLoader("hidden");
    }
  };


  // Helper function for the progress bar/count
  const getProgressBarWidth = () => {
    const maxCount = 3;
    const progress = Math.min(sensitiveFilesUploaded, maxCount) / maxCount;
    return `${progress * 100}%`;
  };

  // Function to simulate file deletion
  const handleDeleteFile = (categoryId, doc) => {
    if (!!doc) {
      setShowLoader("block");
      let docUpdates = [];
      let obj = {
        docId: doc.id,
        fileType: doc.fileType,
        itemType: doc.itemType,
      };
      docUpdates.push(obj);
      let data = {
        userGuid: userGUID,
        docUpdates: docUpdates,
        action: DocumentUpdateActionEnum.trash,
      };
      permanentDeleteDocs(data).then((response) => {
        if (!!response) {
          setUploadedFiles((prev) => ({
            ...prev,
            [categoryId]: prev[categoryId].filter((file) => file.id !== doc.id),
          }));
          setShowLoader("hidden");
        } else {
          setShowLoader("hidden");
        }
      });
    }
  };

  const handleClickNext = () => {
    NavigationHandler(readCookie("userguid"));
    setSuccessPopUp(false);
  }

  const NavigationHandler = (
    validUserGuid,
    isPerquisiteBountyEnable = false,
    isSocialUserExists = false,
    isGuestUser = false,
    isLoggedInUser = false
  ) => {
    let docid = "";
    let type = "";
    if (queryParams.has("docid")) {
      docid = queryParams.get("docid");
    }
    if (queryParams.has("type")) {
      type = queryParams.get("type");
    } else if (queryParams.has("doctype")) {
      type = queryParams.get("doctype");
    }

    NavigationHandlerForPDFsimpli(
      locale,
      "",
      "",
      0,
      isPerquisiteBountyEnable,
      isSocialUserExists,
      isGuestUser,
      isLoggedInUser
    );
  }
  const NavigationHandlerForPDFsimpli = (
      locale,
      docId,
      type,
      numberOfDocs,
      isPerquisiteBountyEnable = false,
      isSocialUserExists,
      isGuestUser,
      isLoggedInUser
    ) => {
      let urlPrefix = "";
      let urlPost = "";
      const validUserGuid = readCookie("userguid");
      urlPrefix = getPdfSimpliBaseURL;

      if (isPricingPageFlow()) {
        urlPost = urlPrefix + "app" + getLinkWithLocale(locale, buildPricingPageUrl());
        window.location.assign(urlPost);
      } else if (isPerquisiteBountyEnable === false && !isGuestUser && !isLoggedInUser) {
        console.log("Non paid user..");
        urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "billing/plans");
        window.location.assign(urlPost);
      } else if (!!type && type.toLowerCase() === "cvlt") {
        urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "cover-letter-review") + "?docid=" + docId;
        window.location.assign(urlPost);
      } else {
        if (!!docId) {
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "review") + "?docid=" + docId;
          window.location.assign(urlPost);
        } else if (numberOfDocs > 0) {
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "resumes");
          window.location.assign(urlPost);
        } else {
          if (isSocialUserExists === true) {
            if (isPricingPageFlow()) {
              urlPrefix = getPdfSimpliBaseURL;
              urlPost = urlPrefix + "app" + getLinkWithLocale(locale, buildPricingPageUrl());
              window.location.assign(urlPost);
            } else if (isLoggedInUser) {
              urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "billing/plans");
            } else {
              urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
            }

            window.location.assign(urlPost);
          } else {
            if (
              (!!validUserGuid && window.location.search !== "" && queryParams.has("ofn")) ||
              queryParams.has("evp")
            ) {
              setIsProcessing(true);
              ProcessSignInRequest(
                queryParams,
                validUserGuid,
                isPerquisiteBountyEnable,
                false,
                isGuestUser,
                locale,
                isLoggedInUser
              ).then((processResponse) => {
                if (!!processResponse) {
                  if (isPricingPageFlow()) {
                    urlPrefix = getPdfSimpliBaseURL;
                    urlPost = urlPrefix + "app" + getLinkWithLocale(locale, buildPricingPageUrl());
                    window.location.assign(urlPost);
                  } else if (isLoggedInUser) {
                    if (isPerquisiteBountyEnable || isGuestUser) {
                      urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
                    } else {
                      urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "billing/plans");
                    }
                  } else {
                    urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
                  }
                } else {
                  if (isPricingPageFlow()) {
                    urlPrefix = getPdfSimpliBaseURL;
                    urlPost = urlPrefix + "app" + getLinkWithLocale(locale, buildPricingPageUrl());
                    window.location.assign(urlPost);
                  } else if (isLoggedInUser) {
                    if (isPerquisiteBountyEnable || isGuestUser) {
                      urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
                    } else {
                      urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "billing/plans");
                    }
                  } else {
                    urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
                  }
                }
                console.log("NavigationHandlerForPDFSimpliSuccess", urlPost);
                window.location.assign(urlPost);
              });
            } else {
              console.log("NavigationHandlerForPDFSimpli", urlPost);
              urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
              window.location.assign(urlPost);
            }
          }
        }
      }
    };

useEffect(() => {
    if (!!userGUID) {
      const searchObject = {
        searchText: null,
        fileTypes: null,
        filterList: {
          isSecure: "true",
          islimitdoc: "false",
        },
        pageSize: 20,
        pageIndex: 0,
      };
        getAllDocuments(searchObject).then((response) => {
            if (!!response && response.length > 0) {
                // 1. Create a map for quick lookup of category ID and sort order
                const categoryMap = new Map();
                documentCategories.forEach((category, index) => {
                    categoryMap.set(category.title, { id: category.id, order: index });
                });

                const LAST_INDEX = documentCategories.length;
                
                // Filter out the welcome guide (PDFSimpli_WELCOME_GUIDEBOOK.pdf)
                let filteredItems = response.filter(
                    (item) => item.itemName !== "PDFSimpli_WELCOME_GUIDEBOOK.pdf"
                );

                // Sort the filtered items (retained from previous logic)
                filteredItems.sort((a, b) => {
                    const orderA = categoryMap.get(a.folderPath)?.order ?? LAST_INDEX;
                    const orderB = categoryMap.get(b.folderPath)?.order ?? LAST_INDEX;
                    return orderA - orderB;
                });
                // 2. Group the items, initializing the result as an EMPTY OBJECT
                const newUploadedFiles = {}; 
                if(filteredItems.length > 0){
                filteredItems.forEach((item) => {
                    const categoryInfo = categoryMap.get(item.folderPath);

                    let categoryId;
                    
                    if (categoryInfo) {
                        // Found a match in the predefined categories
                        categoryId = categoryInfo.id;
                    } else {
                        // Items with folderPath not matching a category title go to 'misc'
                        // This handles both empty folderPath items and non-listed folder names
                        categoryId = "misc";
                    }

                    // *** Key Fix: Initialize the array only if it doesn't exist ***
                    if (!newUploadedFiles[categoryId]) {
                        newUploadedFiles[categoryId] = [];
                    }

                    // Push the document item into the array
                    newUploadedFiles[categoryId].push(item);
                });

                    setUploadedFiles((prev) => ({
                      ...prev,
                      ...newUploadedFiles,
                    }));
                }

                console.log("Fetched and Sorted documents for user:", filteredItems);
                console.log("Grouped documents for state (non-empty keys only):", newUploadedFiles);
            } else {
                console.log("Fetched documents for user:", response);
            }
        });
    }
}, [userGUID]);
  return (
    <div>
      <Header />
      <ReactLoader showloader={showLoader} isProcessing={isProcessing} />
      <div className="min-h-screen bg-gray-50 flex flex-col items-center py-10 px-4 sm:px-6 lg:px-8 bg-secure-bg-rs">
        <div className="w-full max-w-2xl md:p-6">
          <div className="">
            {/* Hidden file input element */}
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              className="hidden"
              accept=".pdf,.docx,.doc,.jpg,.jpeg,.png,.tiff,.tif,.ppt,.pptx,.xls,.xlsx,.odt"
            />

            {/* Header Section */}
            <div className="flex flex-col items-center mb-4 md:mb-6">
              <div className="p-4 rounded-3xl bg-indigo-100 mb-4">
                {/* Document Icon SVG */}
                <svg xmlns="http://www.w3.org/2000/svg" width="66" height="56" viewBox="0 0 66 56" fill="none">
                  <path
                    d="M23 37.3488V39.8488C23 40.5118 23.2634 41.1477 23.7322 41.6165C24.2011 42.0854 24.837 42.3488 25.5 42.3488H40.5C41.163 42.3488 41.7989 42.0854 42.2678 41.6165C42.7366 41.1477 43 40.5118 43 39.8488V37.3488M28 27.3488L33 22.3488M33 22.3488L38 27.3488M33 22.3488C33 22.3488 33.0065 33.8672 33 35.3795M36.2615 10.4923L29.7385 3.9692C29.3099 3.54013 28.801 3.19972 28.2409 2.96742C27.6807 2.73512 27.0803 2.61549 26.4738 2.61536H9.92308C8.08696 2.61536 6.32605 3.34475 5.02772 4.64308C3.72939 5.94141 3 7.70232 3 9.53843V46.4615C3 48.2976 3.72939 50.0585 5.02772 51.3569C6.32605 52.6552 8.08696 53.3846 9.92308 53.3846H56.0769C57.913 53.3846 59.6739 52.6552 60.9723 51.3569C62.2706 50.0585 63 48.2976 63 46.4615V18.7692C63 16.9331 62.2706 15.1722 60.9723 13.8738C59.6739 12.5755 57.913 11.8461 56.0769 11.8461H39.5262C38.3025 11.845 37.1263 11.3581 36.2615 10.4923Z"
                    stroke="#5432FB"
                    strokeWidth="4.61539"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              {/* Responsive heading size */}
              <h1 className="text-xl sm:text-2xl font-semibold text-[#16283D] text-center">Upload your documents</h1>
              <p className="text-[#16283D] mt-1 text-center text-sm sm:text-base">
                Pick a category and upload at least one document to continue:
              </p>
              {error && error !== "" && (
                <p className="text-red-600 text-center font-bold text-sm sm:text-base">{error}</p>
              )}
            </div>

            {/* Progress Bar and Status */}
            <div className="mb-8 md:flex items-center md:gap-4 md:justify-between">
              {/* Responsive progress bar count text size */}
              <div className="flex items-center justify-between text-xs sm:text-sm mb-1 md:mb-0 text-[#16283D]">
                {/* <span>Documents uploaded: {totalFiles}</span> */}
                <span className="truncate">Documents uploaded:</span>
                <span className="flex items-center">
                  <span className="font-semibold">{sensitiveFilesUploaded}</span>
                  <span className="opacity-70">/3</span>
                </span>
                <span className="h-6 w-6 flex items-center justify-center ml-1 sm:ml-2 bg-[#E7F1FF] rounded-full flex-shrink-0">
                  {LightBulbIcon}
                </span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2.5">
                <div
                  className="bg-[#0E77FF] h-2.5 rounded-full transition-all duration-500"
                  style={{ width: getProgressBarWidth() }}
                ></div>
                {/* Responsive progress bar message text size */}
                <p className="text-xs sm:text-sm text-gray-500 mt-2 text-center">
                  {/* {sensitiveFilesUploaded < 3 && (
                    <span className="text-gray-500 md:hidden">
                      We recommend starting with at least 3 sensitive documents
                    </span>
                  )} */}
                  {sensitiveFilesUploaded > 0 && (
                    <span className="text-green-600 md:hidden">
                      We recommend starting with at least 3 sensitive documents
                    </span>
                    // <span className="text-green-600 md:hidden">You've uploaded 3+ sensitive documents. Great!</span>
                  )}
                </p>
              </div>
            </div>

            {/* Document Categories List */}
            <div className="space-y-4 bg-gradient-to-b from-[#F0F0F0]/45 to-transparent p-[10px] rounded-[15px] relative px-0">
              {/* {documentCategories.map((category) => (
                <DocumentCategory
                  key={category.id}
                  category={category}
                  uploadedFiles={uploadedFiles[category.id]}
                  onAddFile={handleAddFileClick}
                  onDeleteFile={handleDeleteFile}
                />
              ))} */}
              {/* {sensitiveFilesUploaded < 3 && (
                <p className="text-[#16283D] hidden md:block text-[10px] text-center p-[10px] bg-white border border-gray-200 rounded-[6px] max-w-[300px] absolute top-[-13px] left-[49px]">
                  We recommend starting with at least 3 sensitive documents
                </p>
              )} */}
              {sensitiveFilesUploaded > 0 && (
                <p className="text-[#16283D] hidden md:block text-[10px] text-center p-[10px] bg-white border border-gray-200 rounded-[6px] max-w-[300px] absolute top-[-13px] left-[49px]">
                  We recommend starting with at least 3 sensitive documents
                </p>
              )}
              {documentCategories.map((category, index) => {
                const files = uploadedFiles?.[category.id];
                // if (!files || files.length === 0) {
                //   return null;
                // }
                return (
                  <DocumentCategory
                    key={category.id}
                    category={category}
                    uploadedFiles={files}
                    onAddFile={handleAddFileClick}
                    onDeleteHandler={handleDeleteFile}
                  />
                );
              })}
            </div>

            {/* Done Button */}
            <div className="mt-4 text-center">
              <button
                className={`px-20 py-[15px] leading-[118%] max-w-[300px] md:min-w-[333px] !font-rethink tracking-[2%] text-md md:text-xl font-bold rounded-[100px] uppercase transition-colors duration-1000 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed ${
                  totalFiles > 0
                    ? "bg-ps-reskin-radial hover:bg-hover-ps-reskin-radial text-white"
                    : "bg-gray-300 text-gray-500 cursor-not-allowed"
                }`}
                disabled={totalFiles === 0}
                onClick={() => setSuccessPopUp(true)}
              >
                DONE
              </button>
              {totalFiles > 0 && (
                <p className="text-[#0E76FF] text-sm md:text-base text-center mt-4">
                  You can proceed after uploading one document
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
      <SuccessPopup isOpen={successPopUp} handleClose={setSuccessPopUp} clickNext={handleClickNext} />
      <Footer />
    </div>
  );
};

export default SecureUpload;
